export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-black/40 px-6 py-12"
        >
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-start justify-between gap-8">
                <div>
                    <div className="flex items-center gap-3 mb-4">
                        <span className="w-8 h-8 bg-amber-500 flex items-center justify-center font-display font-bold text-black text-lg">
                            GV
                        </span>
                        <span className="font-display font-semibold tracking-wide text-lg text-white">
                            LEGACY GV VENTURES
                        </span>
                    </div>
                    <p className="text-sm text-slate-400 max-w-md leading-relaxed">
                        Legacy GV Ventures is a holding company. Every vehicle we acquire is owned
                        by Legacy GV Ventures and leased to Legacy Transit Solutions, the operating
                        partner that runs the road.
                    </p>
                </div>
                <nav className="flex flex-col gap-3">
                    {[
                        ["Assets", "#assets"],
                        ["Holding Company", "#holding"],
                        ["The Plan", "#plan"],
                        ["Enquiry", "#enquiry"],
                    ].map(([label, href]) => (
                        <a
                            key={href}
                            href={href}
                            data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm text-slate-400 hover:text-amber-500 transition-colors"
                        >
                            {label}
                        </a>
                    ))}
                </nav>
            </div>
            <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/5">
                <p className="font-mono2 text-xs text-slate-500 tracking-wide">
                    © {new Date().getFullYear()} Legacy GV Ventures. All rights reserved.
                </p>
            </div>
        </footer>
    );
}
